import React, { Component } from 'react'

import Editor from './Editor'
import Frame from '../Frame'
import Toolbar from './Toolbar'
import { ClassroomManager } from '@helpers'
import { useFileUpdate } from '@components/Classroom/hooks'

class Code extends Component {
  constructor(props) {
    super(props)

    this.state = {
      metadata: {
        mode: 'javascript'
      },
      tabs: ClassroomManager.getTabs('code'),
      active: ClassroomManager.getActive('code')
    }
  }

  componentDidMount() {
    ClassroomManager.observe('frames.code.tabs', this.onTabChange)
    ClassroomManager.observe('frames.code.active', this.onActiveChange)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.metadata.mode !== this.state.metadata.mode)
      ClassroomManager.getEditor('code').setOption(
        'mode',
        this.state.metadata.mode
      )
  }

  componentWillUnmount() {
    ClassroomManager.unobserve('frames.code.tabs', this.onTabChange)
    ClassroomManager.unobserve('frames.code.active', this.onActiveChange)
  }

  init = (editor) => {
    ClassroomManager.attachEditor('code', editor)
  }

  loadFile = (file) => {
    // TODO
    // following causes memory leak, since we dont remove the metadata observer
    // on unmount or file change
    ClassroomManager.loadFile(
      { type: 'code', id: file },
      {
        metadata: (metadata) => {
          this.setState({ metadata })
        }
      }
    )
  }

  onTabChange = () => {
    this.setState({ tabs: ClassroomManager.getTabs('code') })
  }

  onActiveChange = () => {
    this.setState({ active: ClassroomManager.getActive('code') })
  }

  renderToolbar = () => {
    return (
      <Toolbar
        mode={this.state.metadata.mode}
        history={{
          undo: () => ClassroomManager.getEditor('code').undo(),
          redo: () => ClassroomManager.getEditor('code').redo()
        }}
        activate={(mode) =>
          this.props.updateFile({
            id: this.state.active,
            data: {
              metadata: {
                action: 'replace',
                value: { ...this.state.metadata, mode }
              }
            }
          })
        }
        close={this.props.close}
      />
    )
  }

  render() {
    return (
      <Frame
        className='gp-code'
        component={{ title: 'Code', type: 'code' }}
        toolbar={this.renderToolbar()}
        tabDefaultConfig={{}}
        onCreate={() => {}}
        tabs={this.state.tabs}
        active={this.state.active}
      >
        <Editor
          mode={this.state.mode}
          init={this.init}
          loadFile={this.loadFile}
          active={this.state.active}
        />
      </Frame>
    )
  }
}

const CodeWrapper = (props) => {
  const { mutateAsync: updateFile } = useFileUpdate()
  return <Code {...props} updateFile={updateFile} />
}

export default CodeWrapper
